export enum ProspectStage {
  NEW_LEAD = 'NEW_LEAD',
  COMMUNICATING = 'COMMUNICATING',
  PROPOSAL_SENT = 'PROPOSAL_SENT',
  PROPOSAL_PRESENTATION = 'PROPOSAL_PRESENTATION',
  CONVERTED = 'CONVERTED',
}

export enum ProspectAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  STAGE_CHANGED = 'STAGE_CHANGED',
  NOTE_ADDED = 'NOTE_ADDED',
  NOTE_UPDATED = 'NOTE_UPDATED',
  NOTE_DELETED = 'NOTE_DELETED',
  BROKER_ASSIGNED = 'BROKER_ASSIGNED',
  PROPOSAL_SAVED = 'PROPOSAL_SAVED',
  PROPOSAL_DELETED = 'PROPOSAL_DELETED',
  CONVERTED_TO_DEAL = 'CONVERTED_TO_DEAL',
  ARCHIVED = 'ARCHIVED',
  UNARCHIVED = 'UNARCHIVED',
}

export const PROSPECT_STAGE_ORDER: ProspectStage[] = [
  ProspectStage.NEW_LEAD,
  ProspectStage.COMMUNICATING,
  ProspectStage.PROPOSAL_SENT,
  ProspectStage.PROPOSAL_PRESENTATION,
  ProspectStage.CONVERTED,
];

export const PROSPECT_STAGE_DISPLAY_NAMES: Record<ProspectStage, string> = {
  [ProspectStage.NEW_LEAD]: 'New Lead',
  [ProspectStage.COMMUNICATING]: 'Communicating',
  [ProspectStage.PROPOSAL_SENT]: 'Proposal Sent',
  [ProspectStage.PROPOSAL_PRESENTATION]: 'Proposal Presentation',
  [ProspectStage.CONVERTED]: 'Converted',
};
